// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".invitation-container{border-bottom-left-radius:5px;border-bottom-right-radius:5px;padding:1rem;background-color:#fff}.invitation-text-container{padding-bottom:2rem}.invitation-button-container{padding:1rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
